import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";

/**
 * Derives the `{page, chapter_id, kind}` context that Dr. Nesma uses to look
 * up which pre-cached narration to play for the current route.
 */
export function usePageContext() {
  const location = useLocation();
  const params = useParams();

  return useMemo(() => {
    const p = location.pathname;
    if (p === "/" || p === "") return { page: "landing" };
    if (p.startsWith("/dashboard")) return { page: "dashboard" };
    if (p.startsWith("/review")) return { page: "review" };
    if (p.startsWith("/questions")) return { page: "questions" };
    if (p.startsWith("/study-plan")) return { page: "study-plan" };
    if (p.startsWith("/chapter/")) {
      const chapterId = params.id || p.split("/")[2];
      const sp = new URLSearchParams(location.search);
      const kind = sp.get("tab") || "lesson";
      return { page: "chapter", chapter_id: chapterId, kind };
    }
    return { page: "dashboard" };
  }, [location.pathname, location.search, params]);
}
